export const isChrome =
  navigator.userAgent.toLowerCase().indexOf('chrome') > -1 &&
  navigator.vendor.toLowerCase().indexOf('google') > -1
